import { FC, ReactNode } from 'react';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { WarningIcon } from '@shared/assets/icons';
import { WarningTriangleIcon } from '@shared/assets/icons/warning-triangle';
import { ExclamationIcon } from '@shared/assets/icons/exclamation';
import { palette } from '@shared/tokens/palette.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import info from '@features/step-summary-modal/assets/information-circle.png';
import { ALERT_VARIANTS } from './constants';

interface AlertProps {
  variant: ALERT_VARIANTS;
  children: ReactNode;
  icon?: ReactNode;
  maxWidth?: string;
}

const getIcon = (variant: ALERT_VARIANTS, customIcon?: ReactNode) => {
  if (customIcon) return customIcon;

  switch (variant) {
    case ALERT_VARIANTS.ERROR:
      return <WarningIcon color={palette['red-500']} width="16px" height="16px" />;
    case ALERT_VARIANTS.WARNING:
      return <WarningTriangleIcon color={colors.foregroundWarning} width="18px" height="16px" />;
    case ALERT_VARIANTS.INFO:
      return <img src={info} alt="Информация" />;
    case ALERT_VARIANTS.EXCLAMATION:
      return <ExclamationIcon color={palette['orange-400']} width="17px" height="16px" />;
  }
};

export const Alert: FC<AlertProps> = ({ variant, children, icon, maxWidth }) => {
  return (
    <div {...stylex.props(styles.container, styles[variant])} style={{ maxWidth }}>
      {getIcon(variant, icon)}
      <div {...stylex.props(styles.content)}>{children}</div>
    </div>
  );
};
